export default __webpack_public_path__ + "static/media/familia.cb9c2ea3.svg";